import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { firstValueFrom, filter, take } from 'rxjs';

import { I18nService, ThemeService } from '@venecia/services';

@Injectable({ providedIn: 'root' })
export class AppInitializer {

    private readonly router = inject(Router);
    private readonly themeService = inject(ThemeService);
    private readonly i18nService = inject(I18nService);

    async initialize(): Promise<void> {
        await firstValueFrom(
            this.router.events
                .pipe(
                    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
                    take(1),
                )
        );

        this.themeService.initialize();
        return this.i18nService.initialize();
    }
}